export var gold = {
  popupClass: 'monthly',
  title: '골드클래스 1개월권',
  classDetail: [
    '<div class="benefit">',
    '<h5>머니 혜택</h5>',
    '<p>클래스 전용 머니 <b>19조</b> 골드 지급</p>',
    '<p>클래스 데일리 머니 <b>2000억 / 일 1회</b> (총 6조)</p>',
    '<p>보유한도 상향 골드 <b>1500조</b> / 포커칩 <b>1000억</b></p>',
    '<p>클래스 전용 딜러비 <b>2.5%</b> 할인<span>(훌라 3%)</span><br>포커칩 채널 제외</p>',
    '</div>',
    '<div class="benefit">',
    '<h5>아이템 혜택</h5>',
    '<p>클래스 전용 금고 골드 한도 <b>1500조</b> / 포커칩 한도 <b>1000억</b></p>',
    '</div>',
    '<div class="benefit">',
    '<h5>구매 혜택</h5>',
    '<p>클래스 전용 상품 구매 가능</p>',
    '</div>',
    '<div class="benefit">',
    '<h5>보안 서비스 혜택</h5>',
    '<p>보안 SMS 서비스 혜택 제공</p>',
    '</div>',
  ].join(''),
}

export var silver = {
  popupClass: 'monthly',
  title: '실버클래스 1개월권',
  classDetail: [
    '<div class="benefit">',
    '<h5>머니 혜택</h5>',
    '<p>클래스 전용 머니 <b>5.5조</b> 골드 지급</p>',
    '<p>클래스 데일리 머니 <b>1000억 / 일 1회</b> (총 3조)</p>',
    '<p>보유한도 상향 골드 <b>1000조</b> / 포커칩 <b>200억</b></p>',
    '<p>클래스 전용 딜러비 <b>1.5%</b> 할인<span>(훌라 1%)</span><br>포커칩 채널 제외</p>',
    '</div>',
    '<div class="benefit">',
    '<h5>아이템 혜택</h5>',
    '<p>클래스 전용 금고 골드 한도 <b>1000조</b> / 포커칩 한도 <b>200억</b></p>',
    '</div>',
    '<div class="benefit">',
    '<h5>보안 서비스 혜택</h5>',
    '<p>보안 SMS 서비스 혜택 제공</p>',
    '</div>',
  ].join(''),
}

export var booster = {
  popupClass: 'monthly',
  title: '부스터 1개월권',
  classDetail: [
    '<div class="benefit">',
    '<h5>머니 혜택</h5>',
    '<p>보유한도 상향 골드 <b>+500조</b><br><span>(클래스와 동시 사용 시 합산 적용)</span></p>',
    '<p>딜러비 <b>1%</b> 할인 <span>(클래스와 동시 사용 시 합산 적용)</span></p>',
    '<p>딜러비 조건부 추가 <b>0.5%</b> 할인<br><span>(승리머니 50조이상 발생 시 자동 적용)</span></p>',
    '<p>(포커칩 채널 제외)</p>',
    '</div>',
    '<div class="benefit">',
    '<h5>아이템 혜택</h5>',
    '<p>금고 골드 한도 <b>500조</b><br><span>(클래스와 동시 사용 시 한도 합산 적용)</span></p>',
    '</div>',
  ].join(''),
}
